//import liraries
import React, { Component, useEffect, useState, useRef } from "react";
import { View, Text, StyleSheet, ScrollView, FlatList, TouchableOpacity, Pressable, Image, Modal,} from "react-native";
import CHeader from "../../common/CHeader";
import MainContainer from "../../common/CWrapper";
import CText from "../../common/CText";
import { getTripTransactionList, tripIsuranceDisputeDropdown,tripIsuranceRaiseDispute,} from "../../api/tripInsurance";
import CustomButton from "../../common/CustomButton";
import CloseIcon from "../../assets/images/icon_close.png";
import CDropdown from "../../common/CDropdown";
import CustomInput from "../../common/CustomInput";
import Loader from "../../common/Loader";
import ModalAlert from "../../common/ModalAlert";
import CCheckbox from "../../common/CCheckBox";
import RadioButton from "../../common/RadioButton";
import CDocxViewer from "../../common/CDocxViewer";
import { useLocation } from "react-router-dom";
import RootNavigation from "../../utilities/RootNavigation";
import { headingData, AMOUNT_TYPE } from "../../constant/dataHelper";
import useStyles from "./TripCreateRaiseDispute_Styles";

// create a component
const TripCreateRaiseDispute = (props) => {
  const {state} = useLocation()
  const disputeItem= state?.disputeItem
  console.log(disputeItem, "9898989");
  const amountPattern = /^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/;
  const transactionData = [disputeItem];
  const fileInputRef = useRef();
  const styles = useStyles();
  const [loading, setLoading] = useState(false);
  const [frontfile, setFrontImage] = useState("");
  const [backImage, setBackImage] = useState();
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [previewBackImage, setPreviewBackImage] = useState("");
  const [enableSubmmit, setEnableSubmit] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [tncModalVisible, setTncModalVisible] = useState(false);
  const [previewFrontImage, setPreviewFrontImage] = useState("");
  const [previewThirdImage, setPreviewThirdImage] = useState("");
  const [data, setData] = useState("");
  const [disputeType, setDisputeType] = useState("");
  const [disputeAmount, setDisputeAmount] = useState(disputeItem?.price);
  const [disputeRemarks, setDisputeRemarks] = useState("");
  const [debitAmontType, setDebitAmontType] = useState("Full Amount");
  const [alertModal, setAlertModal] = useState({title: "", status: "", message: "", navigateScreen: "", actionButton: "",});


  const onCloseModal = () => {
    if (alertModal.navigateScreen == "home") {
      RootNavigation.navigate("otherServices/insurance")
      setAlertModalVisible(false);
    } else {   setAlertModalVisible(false); }
  };

  const getTransactionList = () => {
    setLoading(true);
    getTripTransactionList()
      .then((res) => {
        setLoading(false);
      }).catch((err) => {
        setLoading(false);
        console.log("Error:getTransactionList - ", err);
      });
  };

  useEffect(() => {
    if (frontfile) {
      let reader = new FileReader();
      reader.onloadend = () => { setPreviewFrontImage(reader.result);};
      reader.readAsDataURL(frontfile);
    }
    if (backImage) {
      let reader = new FileReader();
      reader.onloadend = () => { setPreviewBackImage(reader.result);};
      reader.readAsDataURL(backImage);
    }
    if (frontfile && backImage) setEnableSubmit(true);
    else setEnableSubmit(false);
  }, [frontfile, backImage]);

  const onFrontimageChange = (event) => {
    const file = event.target.files[0];
    const maxFileSize = global?.maxUploadFileSizeInMB;
    var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
    if (file) {
      if (sizeInMB > maxFileSize) {
        setAlertModal({title: "Error", status: "error", message: `Kindly upload Jpeg images upto ${maxFileSize} MB`, navigateScreen: "", actionButton: "OK"});
        setAlertModalVisible(true);
      } else if (file.type === "image/jpeg") {
        setFrontImage(file);
      } else {
        setFrontImage(null);
        setAlertModal({ title: "Error", status: "error", message: "Kindly upload Jpeg images only", navigateScreen: "", actionButton: "OK"});
        setAlertModalVisible(true);
      }} else { setFrontImage(null); }
  };

  const onBackimageChange = (event) => {
    const file = event.target.files[0];
    var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
    const maxFileSize = global?.maxUploadFileSizeInMB;
    if (file) {
      if (sizeInMB > maxFileSize) {
        setAlertModal({title: "Error", status: "error", message: `Kindly upload Jpeg images upto ${maxFileSize} MB`, navigateScreen: "", actionButton: "OK"});
        setAlertModalVisible(true);
      } else if (file.type == "image/jpeg") {
        setBackImage(file);
      } else {
        setBackImage(null);
        setAlertModal({title: "Error", status: "error", message: "Kindly upload Jpeg images only", navigateScreen: "", actionButton: "OK"});
        setAlertModalVisible(true);
      }} else { setBackImage(null); }
  };

  const handlefrontImageClick = (event) => {
    event.preventDefault();
    let element = document.getElementById("upload");
    element.click();
  };
  const handleBackImageClick = (event) => {
    event.preventDefault();
    let element = document.getElementById("uploadBack");
    element.click();
  };

  useEffect(() => {
    getTransactionList();
    getDropDown();
  }, []);

  const getDropDown = () => {
    tripIsuranceDisputeDropdown()
      .then((res) => {
        setData({ getDisputeDropdown: res });
      }).catch(() => { });
  };

  const getDropDownData = (dropdown) => {
    if (dropdown && dropdown.getDisputeDropdown && dropdown.getDisputeDropdown.length > 0) {
      let finalValue = [];
      dropdown.getDisputeDropdown.map((value) => {
        finalValue.push({label: value.reason, value: value.reason,});
      });
      if (disputeType == "") {setDisputeType(finalValue[0]); }
      return finalValue;
    } else { return []; }
  };

  const getMandatory = (type) => {
    let dropdown = data;
    if ( dropdown && dropdown.getDisputeDropdown && dropdown.getDisputeDropdown.length > 0 ) {
      let mandatory = false;
      dropdown.getDisputeDropdown.map((value) => {
        if (value.reason == disputeType) {  mandatory = value.isProofMandatory == 1 ? true : false; }
      });
      return mandatory;
    } else { return true; }
  };

  const getDocumentType = (type) => {
    let dropdown = data;
    if (  dropdown && dropdown.getDisputeDropdown && dropdown.getDisputeDropdown.length > 0 ) {
      let mandatory = "";
      dropdown.getDisputeDropdown.map((value) => {
        if (value.reason == disputeType) { mandatory = value.reqDoc;}
      });
      return mandatory;
    } else { return "";  }
  };

  const onRaiseDispute = () => {
    setLoading(true);
    let uploadPayload = new FormData();
    uploadPayload.append("vrn", disputeItem?.vrn + "");
    uploadPayload.append("transId", disputeItem?.transId + "");
    uploadPayload.append("tollPlaza", disputeItem?.tollPlaza + "");
    uploadPayload.append("price", disputeItem?.price + "");
    uploadPayload.append("dateTime", disputeItem?.dateTime + "");
    uploadPayload.append("location", disputeItem?.location + "");
    uploadPayload.append("statementType", disputeItem?.statementType + "");
    uploadPayload.append("amountType", debitAmontType);
    uploadPayload.append("disputeAmount", disputeAmount + "");
    uploadPayload.append("disputeType", disputeType + "");
    uploadPayload.append("disputeRemarks", disputeRemarks + "");
    previewFrontImage != "" ? uploadPayload.append("img1", previewFrontImage) : uploadPayload.append("img1", "");
    previewBackImage != "" ? uploadPayload.append("img2", previewBackImage) : uploadPayload.append("img2", "");
    previewThirdImage != "" ? uploadPayload.append("img3", previewThirdImage) : uploadPayload.append("img3", "");
    tripIsuranceRaiseDispute(uploadPayload)
      .then((res) => {
        console.log("res", res);
        if (res.statusCode == 1011 || res.statusCode == 1021) {
          setAlertModal({title: "Successful", status: "success", message: res.message, navigateScreen: "home", actionButton: "OK"});
          setAlertModalVisible(true);
          setLoading(false);
        } else if (res.statusCode == -1023 || res.statusCode == -1022 ||  res.statusCode == 500 ) {
          setAlertModal({ title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK"});
          setAlertModalVisible(true);
          setLoading(false);
        } else {}
      }).catch((err) => { setApiLoader(false);});
  };

  const isFullPaymentData = (value) => {
    switch (value) {
      case "Duplicate transaction":
        return true;
      case "Service not availed":
        return true;
      default:
        return false;
    }
  };

  useEffect(() => { if (debitAmontType == "Full Amount") { setDisputeAmount(disputeItem?.price);}}, [debitAmontType]);

  return (
    <MainContainer height={"auto"} paddingBottom={60} paddingTop={0} marginTop>
      <View style={styles.contentWrapper}>
        <CHeader showBack disputeHeader title="Raise a Dispute" onPress={() => RootNavigation.navigate("otherServices/insurance") } showDesc={true} />
        <View style={styles.contentBoxWrapper} >
          <ScrollView horizontal={true}>
            <View style={styles.contentBox} >
              <View style={styles.headerViewStyle}>
                {headingData.map((item) => {
                  return (
                    <View style={styles.headerViewStyle}>
                      <CText.tiTransactionText style={{ width: item.width, minWidth: item.width }}>
                        {item.title}
                      </CText.tiTransactionText>
                      {item.showLine && ( <View style={styles.verticalLineStyle} /> )}
                    </View>
                  );
                })}
              </View>
              <FlatList
                showsVerticalScrollIndicator
                data={transactionData}
                showsHorizontalScrollIndicator
                keyExtractor={(item) => item.id}
                renderItem={({ item, index }) => {
                  return (
                    <View style={[styles.dataViewStyle,{backgroundColor:index % 2 !== 0 ? "#ffffff" : "#E5E5E5", borderBottomRightRadius:index == transactionData.length - 1 ? 15 : null, borderBottomLeftRadius:index == transactionData.length - 1 ? 15 : null }]}>
                      <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}> {item.vrn} </CText.tiTransactionText>
                      <View style={styles.verticalLineStyle} />
                      <CText.tiTransactionText style={{ width: 125, minWidth: 125 }}> {item.dateTime} </CText.tiTransactionText>
                      <View style={styles.verticalLineStyle} />
                      <CText.tiTransactionText style={{ width: 125, minWidth: 125 }}> {item.dateTime} </CText.tiTransactionText>
                      <View style={styles.verticalLineStyle} />
                      <CText.tiTransactionText style={{ width: 185, minWidth: 185 }}> {item.transId} </CText.tiTransactionText>
                      <View style={styles.verticalLineStyle} />
                      <CText.tiTransactionText style={{ width: 230, minWidth: 230 }}> {item.tollPlaza} </CText.tiTransactionText>
                      <View style={styles.verticalLineStyle} />
                      <CText.tiTransactionText style={{ width: 125, minWidth: 125 }}> {item.statementType == "D" ? item.price : "-"} </CText.tiTransactionText>
                      <View style={styles.verticalLineStyle} />
                      <CText.tiTransactionText style={{ width: 125, minWidth: 125 }}> {item.statementType == "C" ? item.price : "-"} </CText.tiTransactionText> 
                      </View>
                  );
                }}/>
            </View>
          </ScrollView>
        </View>
        <View style={styles.contentViewStyle}>
          <View style={{ width: "50%" }}>
            <View style={{ zIndex: 9 }}>
              <CDropdown label="Dispute Type" value={disputeType} onSelect={(value) => setDisputeType(value)} items={getDropDownData(data)} customStyle={{ width: 290 }} mandatoryField={true} lengthValue={25} />
            </View>
            <View style={{ marginTop: 20, zIndex: 8 }}>
              <CustomInput 
                label={"Dispute Amount"}
                value={disputeAmount} 
                onValueChanged={(t) => setDisputeAmount(t)}
                style={{ width: 290 }} 
                flexDirection={"column"}  
                mandatoryField={true}
                pattern={/^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/}
                errorMessage={debitAmontType == "Full Amount" ? "" :"Enter Valid Amount"}
                editable={debitAmontType == "Full Amount" ? false : true}
              />
              <CText.loanAppCardIdValueText style={{ opacity: 0.5 }}>  {"Amount should not be more than debited amount"} </CText.loanAppCardIdValueText>
            </View>
            <View style={{ marginTop: 20 }}>
              <CustomInput label={"Remarks"} value={disputeRemarks}  onValueChanged={(t) => setDisputeRemarks(t)} flexDirection={"column"} multiline={true} style={styles.textInputStyle} mandatoryField={true} maxLength={255} />
            </View>
          </View>
          <View style={{ width: "50%" }}>
            <View style={styles.radioWidget}>
              <RadioButton
                PROP={AMOUNT_TYPE}
                orientation={"row"}
                dir={"row"}
                onSelect={(value) => {
                  value && value.key == "Partial Amount" &&
                    setDisputeAmount("");
                  setDebitAmontType(value.key);
                }}
                redBg
                selectedValue={debitAmontType}
                editable={isFullPaymentData(disputeType) ? true : false}
              />
            </View>
            {getMandatory(disputeType) ? (
              <View style={styles.rcUploadWidget}>
                <Text style={styles.rcText}>{`Upload ${getDocumentType(disputeType)}`}</Text>
                <Text style={styles.fileSizeText}> {`Please ensure image size is ${global?.maxUploadFileSizeInMB}MB max`} </Text>
                <View style={styles.RCUpdate_UploadImageContainer}>
                  {previewFrontImage ? (
                    <View style={styles.imageStyle}>
                      <TouchableOpacity onPress={() => setPreviewFrontImage(null)} style={styles.closeIconLink}>
                        <Image source={CloseIcon}  style={styles.closeIcon} />
                      </TouchableOpacity>
                      <Image  source={previewFrontImage} style={{ width: 135, height: 135, borderRadius:10 }} />
                    </View> ) : (
                    <Pressable style={styles.RCUpdate_ImageUploader}  onPress={handlefrontImageClick}>
                      <View style={styles.RCUpdate_ImageUploader_InnerContainer}>
                        <Text style={styles.RCUpdate_ImageUploader_PlusIcon}> +</Text>
                        <Text style={styles.RCUpdate_ImageUploader_AddText}>  Add Front Image </Text>
                      </View>
                    </Pressable>
                  )}
                  <View>
                    <input 
                    type="file" 
                    onChange={onFrontimageChange} 
                    style={{ display: "none" }} 
                    id="upload" 
                    accept="image/*" 
                    ref={fileInputRef}
                     />
                  </View>
                  <Pressable style={styles.RCUpdate_ImageUploader} onPress={handleBackImageClick}>
                    {previewBackImage ? (
                      <View style={styles.imageStyle}>
                        <TouchableOpacity onPress={() => setPreviewBackImage(null)} style={styles.closeIconLink} >
                          <Image source={CloseIcon} style={styles.closeIcon}  />
                        </TouchableOpacity>
                        <Image source={previewBackImage} style={{ width: 135, height: 135, borderRadius:10 }} />
                      </View>
                    ) : (
                      <View style={styles.RCUpdate_ImageUploader_InnerContainer}>
                        <Text style={styles.RCUpdate_ImageUploader_PlusIcon}> + </Text>
                        <Text style={styles.RCUpdate_ImageUploader_AddText}> Add Back Image </Text>
                      </View>
                    )}
                  </Pressable>
                  <View>
                    <input type="file" onChange={onBackimageChange} style={{ display: "none" }} id="uploadBack" accept="image/*"  ref={fileInputRef} />
                  </View>
                </View>
              </View>
            ) : null}
            <View style={styles.checkBoxViewStyle}>
              <CCheckbox termsText={"I agree to"}  TermsAndCondition={" terms and conditions"} onPress={() => setTncModalVisible(true)} setIsTermsChecked={setIsChecked} isTermsChecked={isChecked} />
            </View>
            <View style={{ width: 170, height: 40, marginTop: 30 }}>
              <CustomButton
                disable={
                  !( disputeType && disputeType.length > 0 &&disputeAmount > 0 &&
                    (debitAmontType == "Partial Amount" ? amountPattern.test(disputeAmount) : true) &&
                    isChecked && (debitAmontType == "Partial Amount" ? disputeAmount < disputeItem?.price :disputeAmount) &&
                    disputeRemarks.length > 0 &&
                    ((getMandatory(disputeType) && previewFrontImage != "") ||
                      !getMandatory(disputeType)) )
                }
                text={"Submit"}
                onPress={
                  !( disputeType && disputeType.length > 0 && disputeAmount > 0 &&
                    (debitAmontType == "Partial Amount" ? amountPattern.test(disputeAmount)  : true) &&
                    isChecked && (debitAmontType == "Partial Amount" ? disputeAmount < disputeItem?.price :disputeAmount) &&
                    disputeRemarks.length > 0 &&
                    ((getMandatory(disputeType) && previewFrontImage != "") || !getMandatory(disputeType)))
                    ? null
                    : () => onRaiseDispute()
                }
              />
            </View>
          </View>
        </View>
      </View>
      {loading && <Loader />}
      {alertModalVisible && (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      )}
       {tncModalVisible && (
          <CDocxViewer type = "FF_TNC" visibility ={setTncModalVisible} />)}
     
    </MainContainer>
  );
};

//make this component available to the app
export default TripCreateRaiseDispute;
